import { ArchiveStarOutlineIcon } from './ArchiveStarOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 05768C3B-09EA-40A8-AC27-F13F734FBB4A
 * name archive-star-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-star-outline.svg
 * tags
 */
export const BoxFavoriteOutlineIcon = ArchiveStarOutlineIcon;
export default BoxFavoriteOutlineIcon